import type { FilterState } from './filter-panel';

function formatFilterDate(iso: string): string {
  return new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));
}

interface FilterPanelPeriodProps {
  filters: FilterState;
}

export function FilterPanelPeriod({ filters }: FilterPanelPeriodProps) {
  if (!filters.dateFrom && !filters.dateTo) return null;

  return (
    <div className="border-t px-4 pt-3" style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
      <p className="mb-1 text-[11px] font-medium text-text-secondary">Periode</p>
      <p className="text-[11px] text-text-tertiary">
        {filters.dateFrom ? formatFilterDate(filters.dateFrom) : '–'}
        {' → '}
        {filters.dateTo ? formatFilterDate(filters.dateTo) : '–'}
      </p>
    </div>
  );
}
